import type { InvoiceQuerySchema } from '@/_pages/invoices/shared/schemas';

import { InvoiceDeliverablesPanel } from './invoice-deliverables-panel';
import { InvoiceDetailsPanel } from './invoice-details-panel';
import { InvoicesBottomSplitView } from './invoices-bottom-split-view';

type InvoiceBottomPanelsProps = {
  activeInvoiceId: string | null;
  listInvoices?: InvoiceQuerySchema[] | undefined;
};

export function InvoiceBottomPanels({ activeInvoiceId, listInvoices }: InvoiceBottomPanelsProps) {
  const hasSelection = Boolean(activeInvoiceId);
  const selectedInvoiceDetail =
    activeInvoiceId != null
      ? ((listInvoices ?? []).find((invoice) => String(invoice.id) === activeInvoiceId) ?? null)
      : null;
  const isLoading = hasSelection && listInvoices == null;
  const isError = !isLoading && hasSelection && selectedInvoiceDetail === null;

  return (
    <InvoicesBottomSplitView
      leftContent={
        <InvoiceDeliverablesPanel
          hasSelection={hasSelection}
          selectedInvoice={selectedInvoiceDetail}
          isLoading={isLoading}
          isError={isError}
        />
      }
      rightContent={
        <InvoiceDetailsPanel
          hasSelection={hasSelection}
          selectedInvoice={selectedInvoiceDetail}
          isLoading={isLoading}
          isError={isError}
        />
      }
    />
  );
}
